import React, { useState, useEffect } from 'react';
import OnOffboardForm from './OnOffboardForm';
import OrderEquipmentForm from './OrderEquipmentForm';
import Icon from './Icon';
import './SelfService.css';

const SelfService = () => {
  const [currentView, setCurrentView] = useState('services');

  const handleServiceClick = (service) => {
    switch (service) {
      case 'onboarding':
        setCurrentView('onboarding');
        break;
      case 'order-equipment':
        setCurrentView('order-equipment');
        break;
      default:
        setCurrentView('services');
    }
  };

  const handleBackToServices = () => {
    setCurrentView('services');
  };

  // Reset to services view when component mounts
  useEffect(() => {
    setCurrentView('services');
  }, []);

  if (currentView === 'onboarding') {
    return <OnOffboardForm onBack={handleBackToServices} />;
  }

  if (currentView === 'order-equipment') {
    return <OrderEquipmentForm onBack={handleBackToServices} />;
  }

  return (
    <div className="selfservice-container">
      <div className="selfservice-header">
        <h2>Self Service</h2>
        <p>Manage your IT requests and equipment needs</p>
      </div>

      <div className="selfservice-grid">
        <div 
          className="service-card"
          onClick={() => handleServiceClick('onboarding')}
        >
          <div className="service-card-header">
            <Icon name="user" size="medium" className="service-icon" />
            <h3>User On/Offboarding</h3>
          </div>
          <div className="service-card-content">
            <p>Request new user accounts or deactivate existing users. Submit requests for user onboarding or offboarding processes.</p>
            <div className="service-features">
              <span className="feature-tag">User Management</span>
              <span className="feature-tag">Account Setup</span>
              <span className="feature-tag">Access Control</span>
            </div>
          </div>
          <div className="service-card-footer">
            <span className="service-action">Start Request →</span>
          </div>
        </div>

        <div 
          className="service-card"
          onClick={() => handleServiceClick('order-equipment')}
        >
          <div className="service-card-header">
            <Icon name="equipment" size="medium" className="service-icon" />
            <h3>Order New Equipment</h3>
          </div>
          <div className="service-card-content">
            <p>Request new hardware and equipment. Browse available reusable assets or order new equipment based on your needs.</p>
            <div className="service-features">
              <span className="feature-tag">Hardware</span>
              <span className="feature-tag">Asset Management</span>
              <span className="feature-tag">Procurement</span>
            </div>
          </div>
          <div className="service-card-footer">
            <span className="service-action">Browse Equipment →</span>
          </div>
        </div>
      </div>

      <div className="selfservice-info">
        <div className="info-card">
          <Icon name="clock" size="medium" className="info-icon" />
          <div className="info-content">
            <h4>Quick Response</h4>
            <p>Most requests are processed within 24-48 hours during business days.</p>
          </div>
        </div>

        <div className="info-card">
          <Icon name="support" size="medium" className="info-icon" />
          <div className="info-content">
            <h4>Need Help?</h4>
            <p>Contact our support team if you need assistance with your requests.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfService;

